import { render, staticRenderFns } from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=template&id=27803f10&scoped=true"
import script from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./TopluGenelTalepGonderIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27803f10",
  null
  
)

export default component.exports